import React, { FC, useCallback, useContext, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { TableSmall } from '../../../../../components/Dashboard/TableSmall'
import { useRest } from '../../../../../components/Context'
import { data, IPortfolioData } from './CurrentPortfolioTableLists'
import { MemoClaimYieldPopup } from './ClaimYieldPopup'
import { useRefresh } from '../../../../../components/Context/useRefresh'
import { AppStateContext } from '../../../../../components/Context/AppStateContext'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
    paddingBottom: theme.spacing(2),
  },
  sectionWrap: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(0, 4, 2, 4),
    background: 'rgb(49,52,58)',
  },
}))

interface CurrentPortfolioSectionProps {
  title: string
}

export const CurrentPortfolio: FC<CurrentPortfolioSectionProps> = ({ title }) => {
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  const { saveIsRefresh } = useRefresh()
  const { getIsRefresh } = useContext(AppStateContext)

  // eslint-disable-next-line
  const [dataItem, setDataItem] = useState<any>({})
  const [isOpenModal, setOpen] = useState<boolean>(false)
  const [refresh, setRefresh] = useState<boolean | undefined>(false)

  useEffect(() => setRefresh(getIsRefresh()), [setRefresh, getIsRefresh])

  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })

  const toggleModal = useCallback(
    (value?: IPortfolioData) => {
      if (value) setDataItem(value)
      setOpen((prevState) => !prevState)
    },
    [setOpen],
  )

  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})

  const loadData = useCallback(async () => {
    let cleanupFunction = false
    setLoading(true)

    rxiosAuth.get(data.request).subscribe(
      // eslint-disable-next-line
      (next: any) => {
        setValues(next)
        if (!cleanupFunction) setLoading(false)
      },
      (error) => {
        toast.error(error)
        setLoading(false)
      },
      () => {
        setLoading(false)
        saveIsRefresh(false)
      },
    )
    cleanupFunction = true
    // eslint-disable-next-line
  }, [data.request, rxiosAuth])

  useEffect(() => {
    ;(async () => {
      await loadData()
    })()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (refresh) {
      ;(async () => {
        await loadData()
      })()
    }
    // eslint-disable-next-line
  }, [refresh])

  const handleUnstake = useCallback(
    // eslint-disable-next-line
    (pushData: IPortfolioData) => {
      let cleanupFunction = false
      setLoading(true)

      // rxiosAuth.post(`staking/unstake`, { asset: pushData.basket, amount: pushData.stake }).subscribe(
      rxiosAuth.post(`staking/unstake`, { asset: 'ETH', amount: '0.00000000000000001' }).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          if (!cleanupFunction) setLoading(false)
        },
        (error) => {
          toast.error(error.response.data.message)
          setLoading(false)
        },
        () => {
          toast.success('Amount was successfully unstaked')
          formMethods.reset()
          saveIsRefresh(true)
          setLoading(false)
        },
      )
      cleanupFunction = true
    },
    // eslint-disable-next-line
    [rxiosAuth],
  )

  return (
    <>
      <Grid item xs={12} className={classes.formWrap}>
        <FormProvider {...formMethods}>
          <Grid item xs={12} className={classes.container}>
            <Typography variant={'h6'}>{title}</Typography>
          </Grid>

          <Grid item xs={12} className={classes.sectionWrap}>
            <TableSmall
              columns={data.columns}
              data={values.portfolio}
              getData={toggleModal}
              loading={loading}
              onUnstake={handleUnstake}
            />
          </Grid>
        </FormProvider>
      </Grid>

      <MemoClaimYieldPopup isOpen={isOpenModal} modalClose={toggleModal} data={dataItem} />
    </>
  )
}
